import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReauth from "./BaseQuery";

export interface User {
  username: string;
  storeName: string;
  free_shipping_value: number;
  default_shipping: number;
  default_weight: number;
  access_scopes: [string];
}

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    fetchUser: builder.query<User, void>({
      query: () => "me",
    }),
    login: builder.mutation<{ data: User, refresh_token: string }, { token: string }>({
      query: ({ token }) => ({
        url: "me",
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      async onQueryStarted(args, { queryFulfilled }) {
        const { data } = await queryFulfilled;
        localStorage.setItem("auth_token", args.token);
        localStorage.setItem("refresh_token", data?.refresh_token);
        localStorage.setItem("user", JSON.stringify(data));
      },
    }),
    logout: builder.mutation<void, void>({
      query: () => ({
        url: "logout",
        method: "POST",
      }),
      async onQueryStarted() {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user");
      },
    }),
    refreshToken: builder.mutation<{ auth_token: string, refresh_token: string }, { refresh_token: string }>({
      query: ({ refresh_token }) => ({
        url: "refresh-token",
        method: "POST",
        body: { refresh_token },
      }),
      async onQueryStarted(_args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          localStorage.setItem("auth_token", data.auth_token);
          localStorage.setItem("refresh_token", data?.refresh_token);
        } catch (error) {
          // If refresh fails, clear tokens
          localStorage.removeItem("auth_token");
          localStorage.removeItem("refresh_token");
          localStorage.removeItem("user");
        }
      },
    }),
  }),
});

export const { useFetchUserQuery, useLoginMutation, useLogoutMutation, useRefreshTokenMutation } =
  authApi;
